/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useRef } from 'react';
import withResize from '@tcp/core/src/components/common/hoc/withResize';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  ARROW_VISIBLE_BP,
  calculateBreakPointByWidth,
  SLIDES_TO_SCROLL_BP,
} from '../config/TrendingInCategoryDesktopCarousel.config';
import TrendingInCategoryDesktopCarousel from './TrendingInCategoryDesktopCarousel.view';
import TrendingInCategoryTile from './TrendingInCategoryTile.view';
import styles from '../styles/TrendingInCategoryRecommendationsCarousel.style';

const HorizontalCarouselDesktop = (props) => {
  const {
    windowSize,
    products,
    onQuickViewOpenClick,
    isHideOriginalPriceAndMarchantTagEnabled,
    isDynamicBadgeEnabled,
    currencySymbol,
    currencyAttributes,
    headerLabel,
    isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
  } = props;
  const tileRef = useRef(null);

  const breakPoint = calculateBreakPointByWidth(windowSize);
  return (
    <>
      <TrendingInCategoryDesktopCarousel
        isArrowVisible={products?.length > ARROW_VISIBLE_BP[breakPoint]}
        tileRef={tileRef}
        defaultTileWidth={265}
        slidesToScroll={SLIDES_TO_SCROLL_BP[breakPoint]}
      >
        <div className="trending-in-category-carousel">
          <div className="carousel-background" />
          <div className="trending-in-category-carousel-header" ref={tileRef}>
            {headerLabel}
          </div>
          {products?.map((product) => {
            const productId = product.generalProductId;
            return (
              <TrendingInCategoryTile
                key={productId}
                product={product}
                isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
                isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                currencySymbol={currencySymbol}
                currencyAttributes={currencyAttributes}
                onQuickViewOpenClick={onQuickViewOpenClick}
                isTrendingInCategoryRecommendationsDisplayBadgeEnabled={
                  isTrendingInCategoryRecommendationsDisplayBadgeEnabled
                }
              />
            );
          })}
        </div>
      </TrendingInCategoryDesktopCarousel>
    </>
  );
};

const ResizableCarouselDesktop = withResize(HorizontalCarouselDesktop);

const renderRecommendationsCarousel = ({
  products,
  onQuickViewOpenClick,
  isHideOriginalPriceAndMarchantTagEnabled,
  isDynamicBadgeEnabled,
  currencySymbol,
  currencyAttributes,
  headerLabel,
  isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
}) => {
  return (
    <div className="trending-in-category-carousel">
      <div className="carousel-background" />
      <div className="trending-in-category-carousel-header">{headerLabel}</div>
      {products?.map((product) => {
        const productId = product?.generalProductId;
        return (
          <TrendingInCategoryTile
            key={productId}
            product={product}
            isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
            isDynamicBadgeEnabled={isDynamicBadgeEnabled}
            currencySymbol={currencySymbol}
            currencyAttributes={currencyAttributes}
            onQuickViewOpenClick={onQuickViewOpenClick}
            isTrendingInCategoryRecommendationsDisplayBadgeEnabled={
              isTrendingInCategoryRecommendationsDisplayBadgeEnabled
            }
          />
        );
      })}
    </div>
  );
};

const renderRecommendations = (props) => {
  const isMobileOrTablet = isClient()
    ? getViewportInfo().isMobile || getViewportInfo().isTablet
    : null;

  if (isMobileOrTablet) {
    return <div className="scroll-container">{renderRecommendationsCarousel(props)}</div>;
  }

  return <ResizableCarouselDesktop {...props} />;
};

const renderRecommendationSkeleton = (headerLabel) => {
  const productSkeleton = [1, 2, 3, 4, 5, 6];
  return (
    <div className="scroll-container">
      <div className="trending-in-category-carousel">
        <div className="carousel-background" />
        <div className="trending-in-category-carousel-header">{headerLabel}</div>
        {productSkeleton.map((item) => {
          return (
            <div className="trending-in-category-recommendation-tile skeleton" key={item}>
              <LoaderSkelton />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TrendingInCategoryRecommendationsCarousel = (props) => {
  const { className, products } = props;

  const headerLabel = getDynamicLabelValues('dynamic.browse_d.lbl_trending_in_category_header');
  const updatedProps = { ...props, headerLabel };

  if (!Array.isArray(products)) {
    return (
      <div className={`${className} trending-in-category-carousel-wrapper`}>
        {renderRecommendationSkeleton(headerLabel)}
      </div>
    );
  }

  if (products?.length > 0) {
    return (
      <div className={`${className} trending-in-category-carousel-wrapper`}>
        {renderRecommendations(updatedProps)}
      </div>
    );
  }

  return null;
};

export default withStyles(TrendingInCategoryRecommendationsCarousel, styles);

export { TrendingInCategoryRecommendationsCarousel as TrendingInCategoryRecommendationsCarouselVanilla };
